import { useCallback, useEffect, useState } from "react";
import api, { inr, fmtDate } from "../../lib/api";

export default function CodDashboard() {
  const [data, setData] = useState(null);

  const load = useCallback(() => api.get("/cod/dashboard").then(({ data }) => setData(data)).catch(() => {}), []);
  useEffect(() => { load(); }, [load]);

  const s = data?.summary;

  return (
    <div data-testid="cod-dashboard-page">
      <h1 className="font-display text-2xl font-bold tracking-tight text-shipany-navy">COD Dashboard</h1>
      <p className="text-sm text-slate-500">Cash-on-delivery collection and settlement reconciliation.</p>

      <div className="mt-6 grid grid-cols-2 gap-4 lg:grid-cols-5">
        {[
          ["Expected (in transit)", s?.expected_in_transit, "text-shipany-blue"],
          ["Collected (delivered)", s?.collected_delivered, "text-emerald-600"],
          ["Pending settlement", s?.pending_settlement, "text-amber-600"],
          ["Settled", s?.settled, "text-slate-700"],
          ["Overdue", s?.overdue, "text-red-600"],
        ].map(([label, val, cls]) => (
          <div key={label} className="rounded-2xl border border-slate-200 bg-white p-4" data-testid={`cod-${label.toLowerCase().replace(/[^a-z]+/g, "-")}`}>
            <p className="text-[10px] font-bold uppercase tracking-widest text-slate-400">{label}</p>
            <p className={`mono mt-2 text-xl font-bold ${cls}`}>{typeof val === "number" ? inr(val) : "—"}</p>
          </div>
        ))}
      </div>

      <div className="mt-6 overflow-x-auto rounded-2xl border border-slate-200 bg-white" data-testid="cod-reconciliation-table">
        <table className="w-full min-w-[820px] text-sm">
          <thead>
            <tr className="bg-shipany-navy text-left text-xs uppercase tracking-wider text-white">
              <th className="px-5 py-3.5">AWB</th><th className="px-4 py-3.5">Courier</th><th className="px-4 py-3.5">COD Amount</th>
              <th className="px-4 py-3.5">Expected</th><th className="px-4 py-3.5">Settled</th><th className="px-4 py-3.5">Difference</th><th className="px-4 py-3.5">Status</th>
            </tr>
          </thead>
          <tbody>
            {(data?.reconciliation || []).map((r) => (
              <tr key={r.settlement_id} className="border-t border-slate-100" data-testid={`cod-row-${r.awb}`}>
                <td className="mono px-5 py-3 font-semibold text-shipany-blue">{r.awb}</td>
                <td className="px-4 py-3 text-slate-500">{r.courier_name}</td>
                <td className="mono px-4 py-3 font-semibold">{inr(r.amount)}</td>
                <td className="px-4 py-3 text-slate-500">{fmtDate(r.expected_date)}</td>
                <td className="mono px-4 py-3">{r.settled_amount != null ? inr(r.settled_amount) : "—"}</td>
                <td className={`mono px-4 py-3 ${r.difference ? (r.difference < 0 ? "text-red-500" : "text-emerald-600") : "text-slate-400"}`}>{r.difference != null ? inr(r.difference) : "—"}</td>
                <td className="px-4 py-3">
                  <span className={`rounded-full px-2.5 py-0.5 text-[11px] font-bold uppercase ${r.status === "settled" ? "bg-emerald-50 text-emerald-600" : r.overdue ? "bg-red-50 text-red-600" : "bg-amber-50 text-amber-600"}`}>
                    {r.status === "settled" ? "Settled" : r.overdue ? "Overdue" : "Pending"}
                  </span>
                </td>
              </tr>
            ))}
            {data && data.reconciliation.length === 0 && <tr><td colSpan={7} className="px-6 py-10 text-center text-slate-400">No COD settlements yet — they appear when COD shipments are delivered.</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
